import React from 'react';
import { Routes, Route } from 'react-router-dom';

import TunerTabPanel from './tunerPanels/TunerTabPanel'
import DetTunerTabPanel from './tunerPanels/DetTunerTabPanel'
import BoardsTabPanel from './tunerPanels/BoardsTabPanel'

export default function TunerTab(props) {
  console.log("render TunerTab");
  
  return (
    <div name="divTunerTab">
      <Routes>
        <Route path="/detector" element={<DetTunerTabPanel/>}/>
        <Route path="/tuner" element={<TunerTabPanel/>} />  
        <Route path="/boards" element={<BoardsTabPanel/>} />
    </Routes>
   </div>
  );
}

